<template>
  <div class="activitiesManage admissionCue">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-activitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{
                $t("ListAllocationManagement.aa")
              }}</span>
              <div class="pull-right">
                <el-button type="primary" @click="importData">{{
                  $t("ListAllocationManagement.ab")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="activitiesManage-container">
            <div class="content">
              <div class="flex-wrap" v-if="selectedData.length == 0">
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666"
                    >{{ $t("ListAllocationManagement.ac") }}：</span
                  >
                  <div class="time-box flex-al">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.ad')"
                      v-model="selectForm.create_starttime"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                      style="width: 140px"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{
                      $t("Crmactivemanage.ae")
                    }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.af')"
                      v-model="selectForm.create_endtime"
                      style="width: 140px"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>

                <div class="flex-al mb20 mr10">
                  <div class="select-box" style="width: 160px">
                    <el-select
                      @change="handleSelect(1)"
                      v-model="selectForm.frommedia_name"
                      clearable
                      filterable
                      :placeholder="$t('ListAllocationManagement.ad')"
                    >
                      <el-option
                        v-for="item in SourceList"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <div class="select-box" style="width: 160px">
                    <el-select
                      @change="handleSelect()"
                      v-model="selectForm.channel_id"
                      clearable
                      filterable
                      :placeholder="$t('ListAllocationManagement.ae')"
                    >
                      <el-option
                        v-for="item in ChannelList"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <div class="select-box" style="width: 120px">
                    <el-select
                      filterable
                      v-model="selectForm.activity_id"
                      class="mr15"
                      style="width: 120px"
                      clearable
                      :placeholder="$t('ListAllocationManagement.af')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in ActivityOption"
                        :key="item.activity_id"
                        :label="item.activity_name"
                        :value="item.activity_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb20">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      :placeholder="$t('ListAllocationManagement.ag')"
                      class="input-cont"
                      style="width: 260px"
                      @clear="handleSelect"
                      v-model="selectForm.keyword"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelect()"
                    >{{ $t("Crmactivemanage.as") }}</el-button
                  >
                </div>
              </div>
              <div class="button-wrapper mb10" v-else>
                <el-button
                  type="warning"
                  size="medium"
                  @click="handleMulFilter"
                >
                  {{ $t("ListAllocationManagement.ah") }}
                </el-button>
                <el-button type="primary" size="medium" @click="handleMulValid">
                  {{ $t("ListAllocationManagement.ai") }}
                </el-button>
              </div>
              <div class="tableList" ref="auto_height_table">
                <normalTableCont
                  ref="multipleTable"
                  @handleSelectionChange="handleSelectionChange"
                  @handleColumnChange="handleColumnChange"
                  :tableData="tableList"
                />
              </div>
              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <el-dialog
      :title="
        isFilter
          ? $t('ListAllocationManagement.ah')
          : $t('ListAllocationManagement.ai')
      "
      v-if="mulVisible"
      class="mulSelect"
      :visible.sync="mulVisible"
      width="450px"
      :before-close="handClose"
    >
      <div class="form">
        <p class="number-tips">
          {{ $t("ListAllocationManagement.aj")
          }}<span style="color: #27aad8"> {{ selectedData.length }} </span
          >{{ $t("ListAllocationManagement.ak") }}:
        </p>
        <ul class="selected-people-container">
          <li
            class="selected-people-item"
            v-for="(item, index) in selectedData"
            :key="index"
          >
            {{ item.client_cnname }}
            <i
              class="el-icon-error"
              style="color: red"
              @click="handleRemove(index)"
            ></i>
          </li>
        </ul>
        <el-form
          label-width="70px"
          ref="mulForm"
          :model="mulForm"
          v-if="isFilter"
        >
          <el-form-item
            :label="$t('ListAllocationManagement.al')"
            prop="main_marketer_id"
            :rules="[
              {
                required: true,
                message: $t('ListAllocationManagement.am'),
              },
            ]"
          >
            <el-select
              v-model="mulForm.main_marketer_id"
              :placeholder="$t('ListAllocationManagement.am')"
              clearable
              filterable
            >
              <el-option
                v-for="item in marketPeopleList"
                :key="item.marketer_id"
                :label="item.marketer_name"
                :value="item.marketer_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <p v-else class="mt20" style="color: #333333; font-size: 14px">
          {{ $t("ListAllocationManagement.an") }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleConfimMul" type="primary" size="small">
          {{ $t("Crmactivemanage.bc") }}
        </el-button>
        <el-button @click="mulVisible = false" size="small">取消</el-button>
      </span>
    </el-dialog>

    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :isTrack="isTrack"
        :ClassMessage="ClassMessage"
        :newclientTags="newclientTags"
        :seeSliderTitle="$t('Header.mmd')"
        :customerId="customerId"
        :isAddTagVisible="false"
        :isHome="true"
        :activeName="activeName"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit"
        @hideUserSliderBox="hideSliderSeeBox"
      ></userSeeing>
    </SliderBox>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";
import normalTableCont from "../../components/tables/switchTableCont.vue";
import userSeeing from "@/components/User/seeing.vue";
import SliderBox from "@/components/SliderBox";

export default {
  name: "Activitiesmanage-activitiesManage",
  data() {
    return {
      ClassMessage: {}, //选择的试听班级
      customerId: "",
      newclientTags: [],
      iscanEdit: false,
      isRoot: false,
      isTrack: false,
      isFilter: false,
      mulForm: { main_marketer_id: "" },
      mulVisible: false,
      ActivityOption: [],
      openMenu: ["1"],
      showSliderBoxCreate: false,
      showSliderBoxEdit: false,
      showSliderBoxSee: false,
      currentPage: 1,
      dialogVisible: false,
      PreviewVisible: false, //活动模板预览图
      DelVisible: false, //删除
      copyItem: false, //复制
      fullscreenLoading: true, //全屏loading
      goalId: "",
      onCodeInfo: {
        oneCodeImg: "", //单个活动的二维码
        oneCodeWxImg: "", //单个活动的二维码---微信
        oneCodeUrl: "", //单个活动的url
      },

      ActivitytempOne: {}, //单个模板信息
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      creatimageUrl: "",
      imageUrl: "",
      dialogimgVisible: false,
      input: "",
      select: "",
      sliderWidth: "800px",
      sliderSeeWidth: "450px",
      activeName: "first",
      activeName1: "first",
      activityId: "", //暂存查看的活动id
      activeOne: {}, //单个活动信息
      infoForm: {
        a_content: "",
        editorOption: {},
      },
      //富文本编辑器
      defaultMsg: this.$t("Crmactivemanage.bd"),
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 350,
      },
      //筛选条件
      selectForm: {
        create_starttime: "",
        create_endtime: "",
        activity_id: "", //活动类型
        channel_id: "", //渠道明细
        frommedia_name: "", //渠道类型
        keyword: "",
      },
      //创建人
      founder: [],
      SourceList: [], //选择渠道类型-下拉数据
      ChannelList: [], //选择渠道明细-下拉数据
      // 发布活动
      aciveCreateInfo: {
        aciveText: this.$t("Crmactivemanage.be"),
        aciveClass: "silder-contain-creat",
      },
      // 编辑活动
      aciveEditInfo: {
        aciveText: this.$t("Crmactivemanage.bf"),
        aciveClass: "silder-contain-edit",
      },
      // 消息详情
      infomationData: [],

      columnWidth: ["200", "250", "200", "200", "200", "200", "auto"], //表格宽度
      // 表格数据
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
      },
      columns: [],
      operates: {
        width: 240,
        label: this.$t("Crmactivemanage.bg"),
        align: "center",
        fixed: "right",
        list: [],
      }, // 列操作按钮
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 表单验证
      rules: {
        activity_name: [
          {
            required: true,
            message: this.$t("Crmactivemanage.bk"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: this.$t("Crmactivemanage.bl"),
            trigger: "blur",
          },
        ],
        activity_starttime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.bm"),
            trigger: "change",
          },
        ],
        activity_endtime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.bn"),
            trigger: "change",
          },
        ],
      },
      promotionVisible: false,
      promotionList: [],
      selectedData: [],
      marketPeopleList: [],
      promotionErrorTip: "",
      tableList: {
        list: [],
        columns: [],
        options: {
          mutiSelect: true,
          tableHeight: null, //表格高度
          errortip: "",
          issetting: false,
        },
      },
    };
  },
  components: {
    PageNav,
    userSeeing,
    normalTableCont,
    SliderBox,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.Home(this.pagenum);
    this.getActivityFounderData(); // 获取目标创建人管理
    this.getSourceApi(); // 获取渠道类型
    this.getActivity(); // 获取渠道类型
    this.getChannelApi(); // 获取渠道明细
    this.getTmkMarketerApi(); //
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(310); //设置表格高度
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  watch: {
    mulVisible(newValue) {
      if (!newValue) {
        this.mulForm.main_marketer_id = "";
        this.$refs["multipleTable"]["$children"][0].clearSelection();
      }
    },
  },
  methods: {
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },

    changeClientToValidApi() {
      CrmActiveManage.changeClientToValidApi({
        clients_json: JSON.stringify(
          this.selectedData.map((item) => ({ client_id: item.client_id }))
        ),
      }).then((res) => {
        this.$refs["multipleTable"]["$children"][0].clearSelection();
        if (res.data.code === 200) {
          (() => {})(res.data.msg);
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.mulVisible = false;
          this.Home(this.pagenum);
        } else {
          this.$Toast({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    allotTmkClientApi() {
      CrmActiveManage.allotTmkClientApi({
        clients_json: JSON.stringify(
          this.selectedData.map((item) => ({ client_id: item.client_id }))
        ),
        main_marketer_id: this.mulForm.main_marketer_id,
        marketer_id: this.$Tool.getStorage("marketer_id"),
      }).then((res) => {
        this.$refs["multipleTable"]["$children"][0].clearSelection();
        if (res.data.code === 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.mulVisible = false;
          this.Home(this.pagenum);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    getTmkMarketerApi() {
      CrmActiveManage.getTmkMarketerApi({}).then((res) => {
        this.marketPeopleList = res.data.data.list;
      });
    },
    handleRemove(index) {
      this.selectedData.splice(index, 1);
      if (this.selectedData.length === 0) {
        this.mulVisible = false;
      }
    },
    handClose(done) {
      done();
    },
    handleConfimMul() {
      if (this.isFilter) {
        this.$refs["mulForm"].validate((isValid) => {
          if (isValid) {
            this.allotTmkClientApi();
          }
        });
      } else {
        this.changeClientToValidApi();
      }
    },
    handleMulValid() {
      this.isFilter = false;
      this.mulVisible = true;
    },
    handleMulFilter() {
      this.isFilter = true;
      this.mulVisible = true;
    },
    handleSelectionChange(val) {
      this.selectedData = [...val];

      if (this.$refs["auto_height_table"]) {
        this.$nextTick(() => {
          this.tableList.options.tableHeight = this.$Common.getTableHeight(
            this.$refs.auto_height_table.getBoundingClientRect().top + 90
          );
        });
      }
    },
    importData() {
      this.$router.push({ path: "/ListAllocationManagement/importGross" });
    },
    getActivity() {
      CrmActiveManage.getActivity({
        company_id: this.company_id,
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
      }).then((res) => {
        this.ActivityOption = res.data.data.list;
      });
    },
    Home() {
      CrmActiveManage.Home({
        create_starttime: this.selectForm.create_starttime,
        create_endtime: this.selectForm.create_endtime,
        activity_id: this.selectForm.activity_id,
        channel_id: this.selectForm.channel_id,
        client_source: this.selectForm.frommedia_name,
        keyword: this.selectForm.keyword,
        isgrossmenu: "1",
        p: this.currentPage,
        num: this.pagesize,
        is_count: "1", // 是否需要总数
        client_isgross: "1", // 是否需要总数
      }).then((res) => {
        let columns = res.data.data.field;
        this.tableList.columns = columns;
        this.tableList.columns.forEach((item) => {
          if (item.fieldname === "client_cnname") {
            item.ismethod = 1;
          }
        });
        this.dataNumber = parseInt(res.data.data.allnum);
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.list = [];
          this.tableList.options.errortip = res.data.msg;
        }
      });
    },
    getSourceApi() {
      this.$http
        .getSourceApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
        })
        .then((res) => {
          this.SourceList = res.data.data.list;
        });
    },
    // 获取渠道明细
    getChannelApi() {
      this.$http
        .getChannelApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
          channel_medianame: this.selectForm.frommedia_name,
        })
        .then((res) => {
          this.ChannelList = res.data.data.list;
        });
    },
    // 选择查询
    handleSelect(v) {
      this.currentPage = 1;
      if (v === 1) {
        this.getChannelApi();
      }
      this.Home(this.pagenum);
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.currentPage = 1;
      this.selectForm.channel_id = "";
      this.getChannelApi(); // 获取渠道明细
      this.Home(this.pagenum);
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.Home(this.pagenum);
    },
    // 复制活动
    copyActivityOneApi() {
      CrmActiveManage.copyActivityOneApi({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId,
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.copyItem = false;
          this.Home(this.pagenum);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handPromotion() {
      CrmActiveManage.GroundPromotionQRcodeApi({
        activity_id: this.activityId,
      }).then((res) => {
        const { code, msg, data: body } = res.data;

        if (code === 200) {
          this.promotionList = body.list;
        } else {
          this.promotionList = [];
        }
        this.promotionErrorTip = msg;
        this.promotionVisible = true;
      });
    },
    // 获取目标创建人管理
    getActivityFounderData() {
      CrmActiveManage.getActivityFounder({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
      }).then((res) => {
        this.founder = res.data.data.data;
      });
    },
    //单个招生活动查看
    getgoalActivityOneData(id) {
      CrmActiveManage.getgoalActivityOne({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: id, //活动 id
      }).then((res) => {
        
        this.infomationData = res.data.data.data;
      });
    },
    // 点击名字查看单个员工
    handleColumnChange(k, c, v) {
      (() => {})(v);
      this.customerId = v.client_id;
      this.newclientTags = v.client_tag;
      this.activityId = v.activity_id;
      this.activeOne = v;
      this.showSliderBoxSee = true;
      this.getgoalActivityOneData(v.activity_id);
    },
    // 点击查看里的编辑
    handClickEdit() {
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
    },
    // 确定删除
    handleDelClickConfim() {
      // 删除招生活动
      CrmActiveManage.delGoalActivity({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId,
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.showSliderBoxEdit = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.Home(this.pagenum);
          this.DelVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    onEditorReady(editor) {
      (() => {})(editor);
    },
    // 预览模版******新建
    perviewTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******新建
    perviewSeeTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 预览模版******编辑
    perviewTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******编辑
    perviewSeeTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 关闭活动模板预览图
    handleClosePreview() {
      this.PreviewVisible = false;
    },
    hideSliderBoxCreate() {
      this.showSliderBoxCreate = false;
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderBoxSee() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    //发布招生活动
    onSubmit(v) {
      // 添加招生活动
      CrmActiveManage.addGoalActivity(v).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.Home(this.pagenum);
          this.showSliderBoxCreate = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //编辑招生活动提交
    onEditSubmit(v) {
      let data = v;
      data.activity_id = this.activityId;
      // 修改招生活动
      CrmActiveManage.updateGoalActivity(data).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.showSliderBoxCreate = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.Home(this.pagenum);
          this.showSliderBoxEdit = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(tab, event) {
      (() => {})(tab, event);
    },
    handleSliderSeeClick(tab, event) {
      (() => {})(tab, event);
    },
    handleClick(v) {
      this.showSliderBoxSee = true;
      (() => {})(v);
      this.activityId = v.activity_id;
      this.activeOne = v;
      this.getgoalActivityOneData(v.activity_id);
    },
    handleCreateClick() {
      this.showSliderBoxCreate = true;
    },
    handleClose(done) {
      this.$confirm(this.$t("Crmactivemanage.bo"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleCloseCode(done) {
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.Home(this.pagenum);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.Home(val);
    },
    //点击查看二维码
    handleCodeChange(k, v, col) {
      if (col.isschool == "1") {
        this.onCodeInfo.oneCodeImg = v.qrcode; //学校二维码
        // axios
        //   .get(`${v.QRcodeUrl}`, {
        //     params: {}
        //   })
        //   .then(res => {
        //     (() => {})(res);
        //     if (res.data.code === 200) {
        //     }
        //   });
        this.onCodeInfo.oneCodeWxImg = v.QRcodeUrl; //学校二维码
        this.onCodeInfo.oneCodeUrl = v.qrcodeurl;
      } else {
        this.onCodeInfo.oneCodeImg = v.personalqrcode; //个人二维码
        this.onCodeInfo.oneCodeWxImg = v.personalQRcodeUrl; //个人二维码
        this.onCodeInfo.oneCodeUrl = v.personalqrcodeurl;
      }
      this.dialogVisible = true;
    },
    onClickPromotionCode(v) {
      this.dialogVisible = true;
      this.onCodeInfo.oneCodeImg = v.personalqrcode; //个人二维码
      this.onCodeInfo.oneCodeWxImg = v.personalQRcodeUrl; //个人二维码
      this.onCodeInfo.oneCodeUrl = v.personalqrcodeurl;
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      for (name in this.selectForm) {
        if (name != "rang_time") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForm[name]}`;
        }
      }
      let url = CrmActiveManage.getsellActivity1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 90
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("../CampusEnrollment/admissionCue.less");
// @import url("crmActiveManage.less");

.activitiesManage {
  height: 100vh;
  font-size: 20px;
  .mulSelect {
    .number-tips {
      font-size: 12px;
      color: #333333;
      margin-bottom: 10px;
    }
    .selected-people-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .selected-people-item {
        padding: 4px 8px;
        margin-right: 10px;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #dedede;
      }
    }
  }
  .code-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      img {
        width: 165px !important;
        height: 165px;
      }
    }
    .left {
      margin-right: 10px;
      .one-img {
        width: 220px;
        height: 220px;
        padding-top: 13px;
      }
      .one-tw-img {
        width: 300px;
        height: 300px;
        margin: 0 auto;

        img {
          width: 100% !important;
          height: 100%;
        }
      }
    }
    .right {
      margin-left: 10px;
    }
    iframe {
      * {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
}
.promotion-drawer {
  height: 100%;
  .promotion-tips {
    display: inline-block;
    color: #f46c6c;
    font-size: 12px;
    margin: 20px;
  }
  .promotion-list {
    width: 448px;
    height: 118px;
    border-radius: 6px;
    border: 1px solid #e5e6e6;
    margin-bottom: 12px;
    margin-left: 24px;
    display: flex;
    align-items: center;
    > img {
      width: 80px;
      height: 80px;
      margin-left: 25px;
      margin-right: 45px;
      cursor: pointer;
    }
    > div {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      display: flex;
      flex-direction: column;
      span {
        display: inline-block;
        width: 70px;
        text-align: right;
      }
    }
  }
  .no-data {
    margin-top: 100px;
    color: #999999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    i {
      display: inline-block;
      font-size: 40px;
      margin-bottom: 20px;
    }
    i:before {
      color: #999999;
    }
  }
}
</style>
